import { translate } from 'infras/i18n';
import { BlogListItem } from 'presentations/api/schema/contents';
import { setBreadcrumbs } from 'presentations/views/helpers/breadcrumbs';
import { useContext } from 'react';
import { ServicePortalContext } from 'presentations/reducers/ServicePortal';
// import searchInsights from 'search-insights';
// import Cookie from 'js-cookie';

export interface Props {
  tag: string | null;
  category: string | null;
  blogs: BlogListItem[];
  breadcrumbs: { title: string; link: string }[];
}

export const useBlogListPage = (props: Props) => {
  const { state: serviceState } = useContext(ServicePortalContext);
  const viewer = serviceState.viewer;

  const routes = setBreadcrumbs(props.breadcrumbs);
  let categoryName = null;
  if (props.category) {
    categoryName = translate(`blog.category.${props.category}`);
  }

  return {
    state: {
      viewer,
      routes,
      categoryName,
    },
    actions: {},
  };
};
